import { Component, OnInit } from "@angular/core";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { ProjectsService } from "../services/projects/projects.service";
import { format } from "date-fns";

@Component({
  selector: "app-bank-cheque-listing",
  templateUrl: "./bank-cheque-listing.component.html",
  styleUrls: ["./bank-cheque-listing.component.css"],
})
export class BankChequeListingComponent implements OnInit {
  templates: any;

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private projectsService: ProjectsService
  ) {}

  ngOnInit() {
    this.getTemplatesList();
  }

  getTemplatesList() {
    this.slimLoadingBarService.start();
    this.projectsService.getBankCheques().subscribe(
      (res: any) => {
        const rows = Array.isArray(res) ? res : res && res.data ? res.data : [];
        this.templates = rows.map((template) => {
          if (template && template.created_at) {
            template.created_at = format(
              new Date(template.created_at),
              "yyyy-MM-dd"
            );
          }
          return template;
        });
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  deleteTemplate(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this cheque template!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.projectsService.deleteBankChequeTemplate(id).subscribe(
          (res: any) => {
            this.slimLoadingBarService.complete();
            swal(
              "success",
              "Deleted cheque template successfully!",
              "success"
            );
            this.getTemplatesList();
          },
          (err) => {
            this.slimLoadingBarService.reset();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/bank-cheque-listing/bank-cheque-listing.component.ts